import http from '@/assets/common/http';
// ------------------------------------------查询延时审核列表
export function queryDelaye(data) {
  const params = {
    SERVICE_ID: '10016',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------拒绝延时审核列表
export function denyDelaye(data) {
  const params = {
    SERVICE_ID: '10016',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------同意延时审核列表
export function agreeDelaye(data) {
  const params = {
    SERVICE_ID: '10016',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------获取项目点名称
export function projectName() {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/delayeOrder.js